<template>
    <div class="pane-content">
        <el-row type="flex" class="mt-2 align-center">
            <h5 class="section-header">Communication Activity</h5>
        </el-row>
        <sync-call-mapper
            class="mt-4"
            :model="model"
            :integration-name="integrationName"
            :integration-name-with-casing="integrationNameWithCasing"
            :static-name="staticName"
        />
        <sync-sms-mapper
            class="mt-4"
            :model="model"
            :integration-name="integrationName"
            :integration-name-with-casing="integrationNameWithCasing"
            :static-name="staticName"
        />
    </div>
</template>

<script>
import SyncCallMapper from './hubspot/sync-call-mapper.vue'
import SyncSmsMapper from './hubspot/sync-sms-mapper.vue'

export default {
    components: {
        SyncCallMapper,
        SyncSmsMapper
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        integrationName: {
            type: String,
            required: true
        },
        integrationNameWithCasing: {
            type: String,
            required: true
        },
        statics: {
            type: Object,
            required: false
        },
    },
    computed: {
        staticName() {
            return this.statics.name || 'Aloware'
        }
    }
}
</script>
<style scoped>
.pane-content {
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    padding-right: 8px;
}

.section-header {
    margin: 0 12px 0 0;
    font-size: 20px;
}

.align-center {
    align-items: center;
}
</style>
